<template>
  <div class="p-3">
    <b-row>
      <b-col> Subscribed to: {{ tally }} </b-col>
      <b-col>
        <b-button pill class="p-3" block :variant="colour" size="lg">
          <font-awesome-icon
            v-if="tallyInputDevice"
            :color="micColour"
            icon="fa-solid fa-microphone"
            size="3x"
          />

          <font-awesome-icon
            v-if="!tallyInputDevice"
            color="yellow"
            icon="fa-solid fa-exclamation-circle"
            size="3x"
          />
        </b-button>
      </b-col>
      <b-col> 
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Tally",
  props: {
    tally: {
      type: String,
      default: "nothing!"
    },
    status: {
      type: String,
    },
    client: {},
  },
  computed: {},

  watch: {
    tally: function() {
      console.log(this.tally);
      this.client.unsubscribe("#", { qos: 2 });
      this.client.subscribe("#", { qos: 2 });
    },
  },

  data: function() {
    return {
      connected: null,
      flag: null,
      tallyInputDevice: null,
      colour: null,
      micColour: "black",
      name: null,
      text: null,
    };
  },

  components: {},
  methods: {},

  beforeMount() {
    this.client.on("message", (topic, message, packet) => {
      var booMessage = message == "1"; //convert string 1 or 0 to boolean
      switch (topic) {
        case this.tally:
          this.flag = booMessage;
          if (booMessage) {
            this.colour = "danger";
            this.micColour = "white";
            this.text = "Mic Live";
            this.$emit("live", true);
          } else {
            this.colour = "secondary";
            this.micColour = "black";
            this.text = "";
            this.$emit("live", false);
          }
          break;
        case this.status:
          console.log(`Input Device Status is: ${booMessage}`);
          this.tallyInputDevice = booMessage;
      }
    });
  },
};
</script>
